type SectionWithItems = {
    items: { isVisible: boolean }[];
};

export const filterVisibleSections = <Section extends SectionWithItems>(sections: Section[]): Section[] =>
    sections
        .map((section) => ({
            ...section,
            items: section.items.filter((item) => item.isVisible),
        }))
        .filter((section) => section.items.length > 0);
